export default {
   network: "https://api.trongrid.io",
   contractAddress: "TBVM1gkRkLduzGe2ibrEcb1SDgqUR9MU6i",
   FEE_LIMIT: 400000000,
   DAY: 86400,
   siteRoot: "http://tronqueen.org",
};
